import React from 'react';
import {connect} from 'react-redux';

import {T} from 'Actions/translate';
import {Checkbox} from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MessageOutlined from '@material-ui/icons/MessageOutlined';
class ReceivePackageCard extends React.Component {
    state = {
        previewReceiveImageDialogOpened: false,
        unReadCount: 3,
    };

    singleHandleCheck = (index, event) => {
        this.props.receiveSingleHandleCheck(index, event);
    };

    viewMessageComment = (sku, packageReceiveIndex, expandLessMessageFlag) => {
        this.props.viewMessageComment(
            sku,
            packageReceiveIndex,
            expandLessMessageFlag,
        );
    };

    render() {
        const {f1PackageReceive, f1MessageList} = this.props;
        console.log('f1PackageReceive===================', f1PackageReceive);
        console.log('this.props.f1MessageList', f1MessageList);
        return (
            <ul className="f1-package-receive-container parent-package-ul"
            testid="f1-receipt-detail-batch">
                {JSON.stringify(f1PackageReceive) !== '{}' &&
                f1PackageReceive.products &&
                f1PackageReceive.products.length > 0
                    ? f1PackageReceive.products.map(
                          (packageReceiveItem, packageReceiveIndex) => (
                              <li
                                  className="parent-receive-li external-li"
                                  key={packageReceiveIndex}
                                  testid={`f1-receipt-detail-sku-${packageReceiveItem.sku}`}>
                                  <div className="parent-sku">
                                      <div className="parent-first-column">
                                          {packageReceiveItem.checked !==
                                          undefined ? (
                                              <div className="checkbox">
                                                  <Checkbox
                                                      checked={
                                                          packageReceiveItem.checked
                                                      }
                                                      inputProps={{
                                                          testid: `f1-receipt-product-checkbox-${packageReceiveItem.sku}`,
                                                      }}
                                                      onChange={this.singleHandleCheck.bind(
                                                          this,
                                                          packageReceiveIndex,
                                                      )}
                                                  />
                                              </div>
                                          ) : null}
                                          <div className="parent-sku-value">
                                              {packageReceiveItem.sku}
                                          </div>
                                      </div>

                                      {f1MessageList &&
                                      f1MessageList[packageReceiveItem.sku] &&
                                      f1MessageList[packageReceiveItem.sku]
                                          .length > 0 ? (
                                          <div className="message-count-container">
                                              <div className="message-count">
                                                  <MessageOutlined />
                                                  <label className="all-count">
                                                      {
                                                          f1MessageList[
                                                              packageReceiveItem
                                                                  .sku
                                                          ].length
                                                      }
                                                  </label>
                                              </div>

                                              <div className="expand-less-icon">
                                                  {packageReceiveItem.expandLessMessageFlag ? (
                                                      <ExpandLessIcon
                                                          onClick={() =>
                                                              this.viewMessageComment(
                                                                  packageReceiveItem.sku,
                                                                  packageReceiveIndex,
                                                                  packageReceiveItem.expandLessMessageFlag,
                                                              )
                                                          }
                                                      />
                                                  ) : (
                                                      <KeyboardArrowDownIcon
                                                          onClick={() =>
                                                              this.viewMessageComment(
                                                                  packageReceiveItem.sku,
                                                                  packageReceiveIndex,
                                                                  packageReceiveItem.expandLessMessageFlag,
                                                              )
                                                          }
                                                      />
                                                  )}
                                              </div>
                                          </div>
                                      ) : null}
                                  </div>
                                  <div className="parent-specifications">
                                      {T('host_product_specifications')}
                                      <span className="specifications">
                                          {packageReceiveItem.specifications}
                                      </span>
                                  </div>
                                  {/* <div className="package-first-row">
                        <div className="parent-first-column">
                            {T('storeCondition')} 
                            <span className="parent-first-column-value">{ packageReceiveItem.storeCondition }</span>
                        </div>
                        <span className="parent-second-column">
                            {T('fone_order_shipping_condition')}
                            <span className="parent-second-column-value">{ packageReceiveItem.shippingCondition }</span>
                        </span>
                    </div> */}
                                  <div className="package-second-row">
                                      <div className="parent-first-column">
                                          {T('host_fone_replenishment_amount')}
                                          <span className="parent-first-column-value"
                                          testid={`f1-receipt-detail-quantity-${packageReceiveItem.sku}`}>
                                              {packageReceiveItem.quantity}
                                          </span>
                                      </div>
                                      <span className="parent-second-column">
                                          {T('fone_order_received_amount')}
                                          <span className="parent-second-column-value"
                                          testid={`f1-receipt-detail-received-quantity-${packageReceiveItem.sku}`}>
                                              {
                                                  packageReceiveItem.receiveQuantity
                                              }
                                          </span>
                                      </span>
                                  </div>
                                  <ul className="f1-sub-package-receive-container sub-package-ul">
                                      {packageReceiveItem.childProducts &&
                                      packageReceiveItem.childProducts.length >
                                          0
                                          ? packageReceiveItem.childProducts.map(
                                                (
                                                    childProductsItem,
                                                    childProductsIndex,
                                                ) => (
                                                    <li
                                                        className="sub-receive-li"
                                                        key={
                                                            childProductsIndex
                                                        }>
                                                        <div className="sub-sku">
                                                            {
                                                                childProductsItem.sku
                                                            }
                                                        </div>
                                                        <div className="package-first-row">
                                                            <div className="parent-first-column">
                                                                {T(
                                                                    'host_lot_information',
                                                                )}
                                                                <span className="parent-first-column-value highlighted-lot">
                                                                    {
                                                                        childProductsItem.lot
                                                                    }
                                                                </span>
                                                            </div>
                                                            <span className="parent-second-column">
                                                                {T(
                                                                    'storeCondition',
                                                                )}
                                                                <span className="parent-second-column-value">
                                                                    {
                                                                        childProductsItem.storeCondition
                                                                    }
                                                                </span>
                                                            </span>
                                                        </div>
                                                        <div className="package-second-row">
                                                            <div className="parent-first-column">
                                                                {T(
                                                                    'shippment_details_shippment_quantity',
                                                                )}
                                                                <span className="parent-first-column-value">
                                                                    {
                                                                        childProductsItem.quantity
                                                                    }
                                                                </span>
                                                            </div>
                                                            <span className="parent-second-column">
                                                                {T(
                                                                    'fone_order_shipping_condition',
                                                                )}
                                                                <span className="parent-second-column-value">
                                                                    {
                                                                        childProductsItem.shippingCondition
                                                                    }
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </li>
                                                ),
                                            )
                                          : null}
                                  </ul>

                                  {packageReceiveItem.expandLessMessageFlag &&
                                  f1MessageList &&
                                  f1MessageList[packageReceiveItem.sku] &&
                                  f1MessageList[packageReceiveItem.sku].length >
                                      0 ? (
                                      <div className="message-list-container">
                                          <h4 className="message-list-title">
                                              {T('host_message_list')}
                                          </h4>
                                          <ul>
                                              {f1MessageList &&
                                                  f1MessageList[
                                                      packageReceiveItem.sku
                                                  ] &&
                                                  f1MessageList[
                                                      packageReceiveItem.sku
                                                  ].length > 0 &&
                                                  f1MessageList[
                                                      packageReceiveItem.sku
                                                  ].map((message) => (
                                                      <li
                                                          key={message.id}
                                                          className="message-item-container">
                                                          <div className="message-timestamp">
                                                              <div>
                                                                  {
                                                                      message.fromUserName
                                                                  }
                                                              </div>
                                                              <div>
                                                                  {
                                                                      message.updateTime
                                                                  }
                                                              </div>
                                                          </div>
                                                          <div className="message-content">
                                                              {message.content}
                                                          </div>
                                                      </li>
                                                  ))}
                                          </ul>
                                      </div>
                                  ) : null}
                              </li>
                          ),
                      )
                    : null}
            </ul>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, localData} = state;
    return {
        shipmentOrOrderDetails: host.shipmentOrOrderDetails,
        skuInventoryDetails: host.skuInventoryDetails,
        localData,
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ReceivePackageCard);
